import type { SVGProps } from "react"

export default function ShareLinkedIn(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.58333 5.41667C7.58333 6.33714 6.83714 7.08333 5.91667 7.08333C4.99619 7.08333 4.25 6.33714 4.25 5.41667C4.25 4.49619 4.99619 3.75 5.91667 3.75C6.83714 3.75 7.58333 4.49619 7.58333 5.41667ZM7.66667 8.66667H4.16667V21.6667H7.66667V8.66667ZM14.0833 8.66667H10.6V21.6667H14.0833V14.8958C14.0833 11.2208 18.8333 10.8875 18.8333 14.8958V21.6667H22.3333V13.6292C22.3333 7.83333 15.6458 8.05417 14.0833 10.9125V8.66667Z"
        fill="#191919"
      />
    </svg>
  )
}
